import React from 'react';
import { PerformancePageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { useAdStudioInlineChart } from './hooks/use-inline-chart';
import { useInlineDownload } from './hooks/use-inline-download';
import { useDatePicker } from './hooks/use-date-picker';
import { useCommonColumn } from './hooks/use-common-columns';
import { useDetailList } from './hooks/use-detail-list';
import { useToolbarContainer } from './hooks/use-toolbar-container';
import { notificationApi } from '../../adapters/get-notification';
import { createFolderFilterQuery } from '../../services/service-utils';

const globalLegacyI18n = window && window.globalLegacyI18n;

export const PerformancePage = (props) => {
  const {
    serverContext, navigation, minDate, i18n, disableCompare, perfMetricDateRange, updateGlobalWaterfallFilter, outRenderInlineChart, isHideShowGraphButton,
  } = props;

  const { renderDatePicker } = useDatePicker({
    serverContext, minDate, i18n, disableCompare, perfMetricDateRange, updateWaterfallFilter: updateGlobalWaterfallFilter,
  });

  const { renderInlineChart, getChartPreference } = useAdStudioInlineChart({
    serverContext,
    globalLegacyI18n,
    // forceToResizeChart,
  });

  const { renderHeaderWithPopup } = useCommonColumn();
  const { renderDetailsList } = useDetailList();
  const { renderToolbarContainer } = useToolbarContainer({ isHideShowGraphButton });

  const onClick = () => {
    navigation.gotoHomePage();
  };

  return (
    <PerformancePageComponent
      renderInlineChart={outRenderInlineChart || renderInlineChart}
      getChartPreference={getChartPreference}
      globalLegacyI18n={globalLegacyI18n}
      onGotoLandingPage={onClick}
      onGoBack={navigation.goBack}
      useInlineDownload={useInlineDownload}
      notificationApi={notificationApi}
      renderDatePicker={renderDatePicker}
      renderDetailsList={renderDetailsList}
      renderToolbarContainer={renderToolbarContainer}
      renderHeaderWithPopup={renderHeaderWithPopup}
      createFolderFilterQuery={createFolderFilterQuery}
      {...props}
    />
  );
};
